import { Info } from "lucide-react";

function SoftWarning() {
  return (
    <section className="mx-auto w-full max-w-7xl px-5 lg:px-8" aria-label="Content note">
      <div className="glass-panel flex items-start gap-4 rounded-lg p-5">
        <Info className="mt-1 shrink-0 text-museum-gold" size={20} aria-hidden="true" />
        <p className="text-sm leading-7 text-museum-muted">
          This experience discusses fear, anxiety, and unsettling human emotions. It is not a medical tool and does not diagnose anything.
        </p>
      </div>
    </section>
  );
}

export default SoftWarning;
